import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "../../_extension/with-set-props";

export const User = types
  .model({
    id: types.maybeNull(types.string),
    creationTime: types.maybeNull(types.string),
    creatorId: types.maybeNull(types.string),
    lastModificationTime: types.maybeNull(types.string),
    lastModifierId: types.maybeNull(types.string),
    isDeleted: types.maybeNull(types.boolean),
    deleterId: types.maybeNull(types.string),
    deletionTime: types.maybeNull(types.string),
    tenantId: types.maybeNull(types.string),
    userName: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    surname: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    emailConfirmed: types.maybeNull(types.boolean),
    phoneNumber: types.maybeNull(types.string),
    phoneNumberConfirmed: types.maybeNull(types.boolean),
    isActive: types.maybeNull(types.boolean),
    lockoutEnabled: types.maybeNull(types.boolean),
    accessFailedCount: types.maybeNull(types.number),
    lockoutEnd: types.maybeNull(types.string),
    concurrencyStamp: types.maybeNull(types.string),
    entityVersion: types.maybeNull(types.number),
    lastPasswordChangeTime: types.maybeNull(types.string),
    userId: types.maybeNull(types.string),
  })
  .actions(withSetPropAction);
export interface IUser extends Instance<typeof User> {}
export interface IUserProperties extends SnapshotIn<typeof User> {}
